import { scrollToOnThisPageTarget } from "./OnThisPage.js";

const MetastaticToggle = {
    init: function () {
        const nonMetastaticButton = document.getElementById("nonmetastatic-toggle");
        const metastaticButton = document.getElementById("metastatic-toggle");

        if (!nonMetastaticButton || !metastaticButton) {
            return;
        }

        applyMetastaticState(
            new URLSearchParams(window.location.search).get("mtab") === "metastatic",
            nonMetastaticButton,
            metastaticButton
        );

        const study = new URLSearchParams(window.location.search).get("study");

        const studyDesign = studyDesignByName[study];

        if (studyDesign) {
            openStudyDesign(studyDesign);
        }

        // const params = new URLSearchParams(window.location.search);
        // if (params.get('mtab') === 'metastatic') {
        //     // document.body.classList.remove("nonmetastatic");
        //     // document.body.classList.add("metastatic");
        //     metastaticButton.classList.add("active");
        //     nonMetastaticButton.classList.remove("active");
        //     window.scrollTo({ top: 0, behavior: 'smooth' });
        // }

        nonMetastaticButton.addEventListener("click", function () {
            document.body.classList.remove("metastatic");
            document.body.classList.add("nonmetastatic");
            nonMetastaticButton.classList.add("active");
            metastaticButton.classList.remove("active");
            window.scrollTo({ top: 0, behavior: 'smooth' });
            // Get the current URL
            const currentURL = new URL(window.location.href);

            // Modify the 'search' parameter
            currentURL.searchParams.delete('mtab');

            // Push the updated URL to history
            window.history.pushState({}, '', currentURL);
            
        });

        metastaticButton.addEventListener("click", function () {
            document.body.classList.remove("nonmetastatic");
            document.body.classList.add("metastatic");
            metastaticButton.classList.add("active");
            nonMetastaticButton.classList.remove("active");
            window.scrollTo({ top: 0, behavior: 'smooth' });
            // Get the current URL
            const currentURL = new URL(window.location.href);

            // Modify the 'search' parameter
            currentURL.searchParams.set('mtab', 'metastatic');

            // Push the updated URL to history
            window.history.pushState({}, '', currentURL);
        });

        window.addEventListener('popstate', (event) => {
            const params = new URLSearchParams(window.location.search);
            applyMetastaticState(
                params.get('mtab') === 'metastatic',
                nonMetastaticButton,
                metastaticButton
            );
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
};

function applyMetastaticState(isMetastatic, nonMetastaticButton, metastaticButton) {
    metastaticButton.classList.toggle("active", isMetastatic);
    nonMetastaticButton.classList.toggle("active", !isMetastatic);
    document.body.classList.toggle("metastatic", isMetastatic);
    document.body.classList.toggle("nonmetastatic", !isMetastatic);
}

const studyDesignByName = {
    "prevail-design": {
        cardId: "efficacy-in-the-prevail-trial",
        targetSelectors: [
            ".additional-content h1",
            ".additional-content h2",
            ".additional-content h3",
            ".additional-content h4",
            ".additional-content h5",
            ".additional-content h6",
            ".additional-content",
            ".expand-button-container",
            ".expand-button"
        ],
        verticalOffset: -50
    },
    "prosper-design": {
        cardId: "metastasis-Free-survival",
        targetSelectors: [
            ".additional-content h1",
            ".additional-content h2",
            ".additional-content h3",
            ".additional-content h4",
            ".additional-content h5",
            ".additional-content h6",
            ".additional-content",
            ".expand-button-container",
            ".expand-button"
        ],
        verticalOffset: -135
    },
    "arches-design": {
        cardId: "radiographicProgressionFreeSurvival",
        targetSelectors: [
            ".additional-content h1",
            ".additional-content h2",
            ".additional-content h3",
            ".additional-content h4",
            ".additional-content h5",
            ".additional-content h6",
            ".additional-content",
            ".expand-button-container",
            ".expand-button"
        ],
        verticalOffset: -45
    },
    "embark-design": {
        cardId: "mfsXtandiGnRHTherapy",
        targetSelectors: [
            ".additional-content h1",
            ".additional-content h2",
            ".additional-content h3",
            ".additional-content h4",
            ".additional-content h5",
            ".additional-content h6",
            ".additional-content",
            ".expand-button-container",
            ".expand-button"
        ],
        verticalOffset: -135
    }
};

function openStudyDesign({ cardId, targetSelectors, verticalOffset = 0 }) {
    const studyCard = document.getElementById(cardId);

    if (!studyCard) {
        return;
    }

    const studyDesignButton = studyCard.querySelector(".expand-button");
    const studyDesignButtonContainer = studyCard.querySelector(
        ".expand-button-container"
    );
    const expandedContent = studyCard.querySelector(".additional-content");
    const targetElement = targetSelectors
        .map(selector => studyCard.querySelector(selector))
        .find(Boolean);

    studyCard.classList.add("expanded");

    window.setTimeout(() => {
        scrollToOnThisPageTarget(
            targetElement ||
                expandedContent ||
                studyDesignButtonContainer ||
                studyDesignButton ||
                studyCard,
            {
                updateHash: false,
                verticalOffset
            }
        );
    }, 0);
}

export { MetastaticToggle };
